module.exports = __webpack_public_path__ + "img/marcador1.19005e61.svg";